// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseCompletionStepDetail } from './ResponseCompletionStepDetail';
import {
  ResponseCompletionStepDetailFromJSON,
  ResponseCompletionStepDetailFromJSONTyped,
  ResponseCompletionStepDetailToJSON,
  ResponseCompletionStepDetailToJSONTyped,
} from './ResponseCompletionStepDetail';
import type { ResponseUnreachableCluster } from './ResponseUnreachableCluster';
import {
  ResponseUnreachableClusterFromJSON,
  ResponseUnreachableClusterFromJSONTyped,
  ResponseUnreachableClusterToJSON,
  ResponseUnreachableClusterToJSONTyped,
} from './ResponseUnreachableCluster';
import type { ResponseConditionCount } from './ResponseConditionCount';
import {
  ResponseConditionCountFromJSON,
  ResponseConditionCountFromJSONTyped,
  ResponseConditionCountToJSON,
  ResponseConditionCountToJSONTyped,
} from './ResponseConditionCount';
import type { ResponseSkippedResourcesForKind } from './ResponseSkippedResourcesForKind';
import {
  ResponseSkippedResourcesForKindFromJSON,
  ResponseSkippedResourcesForKindFromJSONTyped,
  ResponseSkippedResourcesForKindToJSON,
  ResponseSkippedResourcesForKindToJSONTyped,
} from './ResponseSkippedResourcesForKind';
import type { ResponseStepDetail } from './ResponseStepDetail';
import {
  ResponseStepDetailFromJSON,
  ResponseStepDetailFromJSONTyped,
  ResponseStepDetailToJSON,
  ResponseStepDetailToJSONTyped,
} from './ResponseStepDetail';
import type { ResponseResourceProgress } from './ResponseResourceProgress';
import {
  ResponseResourceProgressFromJSON,
  ResponseResourceProgressFromJSONTyped,
  ResponseResourceProgressToJSON,
  ResponseResourceProgressToJSONTyped,
} from './ResponseResourceProgress';
import type { ResponseRolloutAction } from './ResponseRolloutAction';
import {
  ResponseRolloutActionFromJSON,
  ResponseRolloutActionFromJSONTyped,
  ResponseRolloutActionToJSON,
  ResponseRolloutActionToJSONTyped,
} from './ResponseRolloutAction';
import type { ResponseStaleCluster } from './ResponseStaleCluster';
import {
  ResponseStaleClusterFromJSON,
  ResponseStaleClusterFromJSONTyped,
  ResponseStaleClusterToJSON,
  ResponseStaleClusterToJSONTyped,
} from './ResponseStaleCluster';
import type { ResponseRolloutStatus } from './ResponseRolloutStatus';
import {
  ResponseRolloutStatusFromJSON,
  ResponseRolloutStatusFromJSONTyped,
  ResponseRolloutStatusToJSON,
  ResponseRolloutStatusToJSONTyped,
} from './ResponseRolloutStatus';

/**
 *
 * @export
 * @interface ResponseRollout
 */
export interface ResponseRollout {
  /**
   * Actions are the user actions recorded for this rollout, oldest first.
   * @type {Array<ResponseRolloutAction>}
   * @memberof ResponseRollout
   */
  actions?: Array<ResponseRolloutAction>;
  /**
   * ClusterRolloutCount is the number of clusters holding the rollout.
   * @type {number}
   * @memberof ResponseRollout
   */
  clusterRolloutCount?: number;
  /**
   * CompletedAt is when the last cluster completed; omitted until every
   * cluster has.
   * @type {string}
   * @memberof ResponseRollout
   */
  completedAt?: string;
  /**
   * CompletionStep is the step after the last configured step, which moves
   * the resources no other step targeted. The operator keeps it outside the
   * configured steps, so it has no index and cannot be approved.
   * @type {ResponseCompletionStepDetail}
   * @memberof ResponseRollout
   */
  completionStep?: ResponseCompletionStepDetail;
  /**
   *
   * @type {Array<ResponseConditionCount>}
   * @memberof ResponseRollout
   */
  conditions?: Array<ResponseConditionCount>;
  /**
   *
   * @type {string}
   * @memberof ResponseRollout
   */
  identifier?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseRollout
   */
  operatorName?: string;
  /**
   * ResourceProgresses is merged across every step and cluster.
   * @type {Array<ResponseResourceProgress>}
   * @memberof ResponseRollout
   */
  resourceProgresses?: Array<ResponseResourceProgress>;
  /**
   * SkippedResources are the resources carrying the skip annotation, per
   * resource kind and merged across clusters.
   * @type {Array<ResponseSkippedResourcesForKind>}
   * @memberof ResponseRollout
   */
  skippedResources?: Array<ResponseSkippedResourcesForKind>;
  /**
   * StaleClusters lists clusters whose watch is failing, so their state is
   * last-known; omitted when every watch is healthy.
   * @type {Array<ResponseStaleCluster>}
   * @memberof ResponseRollout
   */
  staleClusters?: Array<ResponseStaleCluster>;
  /**
   * StartedAt is when the first cluster started; omitted until one has.
   * @type {string}
   * @memberof ResponseRollout
   */
  startedAt?: string;
  /**
   * Status is derived from the conditions of every cluster copy.
   * @type {ResponseRolloutStatus}
   * @memberof ResponseRollout
   */
  status?: ResponseRolloutStatus;
  /**
   *
   * @type {Array<ResponseStepDetail>}
   * @memberof ResponseRollout
   */
  steps?: Array<ResponseStepDetail>;
  /**
   * TransferFinishedAt is when the last cluster finished transferring;
   * omitted until every cluster has.
   * @type {string}
   * @memberof ResponseRollout
   */
  transferFinishedAt?: string;
  /**
   * UnreachableClusters lists clusters that couldn't be reached while
   * building this view; omitted when every cluster responded.
   * @type {Array<ResponseUnreachableCluster>}
   * @memberof ResponseRollout
   */
  unreachableClusters?: Array<ResponseUnreachableCluster>;
}

/**
 * Check if a given object implements the ResponseRollout interface.
 */
export function instanceOfResponseRollout(
  value: object,
): value is ResponseRollout {
  return true;
}

export function ResponseRolloutFromJSON(json: any): ResponseRollout {
  return ResponseRolloutFromJSONTyped(json, false);
}

export function ResponseRolloutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseRollout {
  if (json == null) {
    return json;
  }
  return {
    actions:
      json['actions'] == null
        ? undefined
        : (json['actions'] as Array<any>).map(ResponseRolloutActionFromJSON),
    clusterRolloutCount:
      json['clusterRolloutCount'] == null
        ? undefined
        : json['clusterRolloutCount'],
    completedAt: json['completedAt'] == null ? undefined : json['completedAt'],
    completionStep:
      json['completionStep'] == null
        ? undefined
        : ResponseCompletionStepDetailFromJSON(json['completionStep']),
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(
            ResponseConditionCountFromJSON,
          ),
    identifier: json['identifier'] == null ? undefined : json['identifier'],
    operatorName:
      json['operatorName'] == null ? undefined : json['operatorName'],
    resourceProgresses:
      json['resourceProgresses'] == null
        ? undefined
        : (json['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressFromJSON,
          ),
    skippedResources:
      json['skippedResources'] == null
        ? undefined
        : (json['skippedResources'] as Array<any>).map(
            ResponseSkippedResourcesForKindFromJSON,
          ),
    staleClusters:
      json['staleClusters'] == null
        ? undefined
        : (json['staleClusters'] as Array<any>).map(
            ResponseStaleClusterFromJSON,
          ),
    startedAt: json['startedAt'] == null ? undefined : json['startedAt'],
    status:
      json['status'] == null
        ? undefined
        : ResponseRolloutStatusFromJSON(json['status']),
    steps:
      json['steps'] == null
        ? undefined
        : (json['steps'] as Array<any>).map(ResponseStepDetailFromJSON),
    transferFinishedAt:
      json['transferFinishedAt'] == null
        ? undefined
        : json['transferFinishedAt'],
    unreachableClusters:
      json['unreachableClusters'] == null
        ? undefined
        : (json['unreachableClusters'] as Array<any>).map(
            ResponseUnreachableClusterFromJSON,
          ),
  };
}

export function ResponseRolloutToJSON(json: any): ResponseRollout {
  return ResponseRolloutToJSONTyped(json, false);
}

export function ResponseRolloutToJSONTyped(
  value?: ResponseRollout | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    actions:
      value['actions'] == null
        ? undefined
        : (value['actions'] as Array<any>).map(ResponseRolloutActionToJSON),
    clusterRolloutCount: value['clusterRolloutCount'],
    completedAt: value['completedAt'],
    completionStep: ResponseCompletionStepDetailToJSON(value['completionStep']),
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(ResponseConditionCountToJSON),
    identifier: value['identifier'],
    operatorName: value['operatorName'],
    resourceProgresses:
      value['resourceProgresses'] == null
        ? undefined
        : (value['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressToJSON,
          ),
    skippedResources:
      value['skippedResources'] == null
        ? undefined
        : (value['skippedResources'] as Array<any>).map(
            ResponseSkippedResourcesForKindToJSON,
          ),
    staleClusters:
      value['staleClusters'] == null
        ? undefined
        : (value['staleClusters'] as Array<any>).map(
            ResponseStaleClusterToJSON,
          ),
    startedAt: value['startedAt'],
    status: ResponseRolloutStatusToJSON(value['status']),
    steps:
      value['steps'] == null
        ? undefined
        : (value['steps'] as Array<any>).map(ResponseStepDetailToJSON),
    transferFinishedAt: value['transferFinishedAt'],
    unreachableClusters:
      value['unreachableClusters'] == null
        ? undefined
        : (value['unreachableClusters'] as Array<any>).map(
            ResponseUnreachableClusterToJSON,
          ),
  };
}
